import { render, staticRenderFns } from "./crudOrdersReason.vue?vue&type=template&id=1254a6cc"
import script from "./crudOrdersReason.vue?vue&type=script&lang=js"
export * from "./crudOrdersReason.vue?vue&type=script&lang=js"
import style0 from "./crudOrdersReason.vue?vue&type=style&index=0&id=1254a6cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports